import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import { finleyAssert } from '@finley-technologies/common';
import { CreditAgreement } from '@finley-technologies/finley-types';

import { Interest } from './Interest';
import { Floor, Margin } from './Margin';
import { Maturity } from './Maturity';
import { PricingOption } from './PricingOption';
import { Typography } from 'packages/common-frontend/components/Typography';

type LoansProps = {
  loans: NonNullable<
    CreditAgreement.DomainEntity.CreditAgreementFullArtifact['loanMechanicsV1']
  >['loans'];
  pricingOptions: NonNullable<
    CreditAgreement.DomainEntity.CreditAgreementFullArtifact['loanMechanicsV1']
  >['pricingOptions'];
};

export const Loans = ({ loans, pricingOptions }: LoansProps) => {
  return (
    <>
      {loans.map(({ key, name, pricingOptionKey, interest, maturity }) => {
        const pricingOption = pricingOptions.find(
          (currPricingOption) => pricingOptionKey === currPricingOption.key,
        );

        finleyAssert(
          pricingOption,
          `Expected pricing option configured for key [${pricingOptionKey}]`,
        );

        return (
          <Box key={key} borderWidth="1px" p="2rem" w="100%">
            <Typography variant="section-subtitle">{name}</Typography>
            <Flex
              flexDirection="column"
              alignContent="flex-start"
              gap="2em"
              w="100%"
            >
              <Typography variant="section-subtitle">Pricing Option</Typography>
              <PricingOption pricingOption={pricingOption} />
              <Margin margin={pricingOption.margin} />
              <Floor pricingOption={pricingOption} />
              <Interest interest={interest} />
              <Maturity maturity={maturity} />
              {/* @jendevelops TODO: display rollover property */}
              {/* <Rollover rollover={loan.rollover} /> */}
            </Flex>
          </Box>
        );
      })}
    </>
  );
};
